import React from 'react';
import { LightBulbIcon } from '@heroicons/react/24/outline';


const QuickTips = () => {
  const tips = [
    { tip: 'Take short breaks every 25 minutes to stay focused.', emoji: '⏰' },
    { tip: 'Review your notes daily to retain more information.', emoji: '📝' },
    { tip: 'Ask questions when you’re curious—it’s how you grow!', emoji: '❓' },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-glass border-b-4 border-purple-600 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 flex items-center">
        <LightBulbIcon className="w-8 h-8 mr-3 text-purple-600" />
        Quick Tips
      </h2>
      <p className="text-lg text-gray-700 mb-4">Boost your learning with these helpful tips!</p>
      <ul className="space-y-3">
        {tips.map((tip, index) => (
          <li
            key={index}
            className="flex items-center bg-purple-50 p-3 rounded-lg shadow-sm hover:bg-purple-100 transition-all duration-200"
          >
            <span className="text-2xl mr-3">{tip.emoji}</span>
            <span className="text-gray-800">{tip.tip}</span>
          </li>
        ))}
      </ul>
      <button className="mt-4 w-full bg-purple-600 text-white py-2 rounded-full font-semibold hover:bg-purple-700 transition-colors shadow-md">
        Explore More Tips
      </button>
    </div>
  );
};
export default QuickTips;